import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownControl } from '../../../form-models/dropdown-control';

@Component({
  selector: 'hb-df-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown-style.scss'],
})
export class DropdownComponent {
  @Input() public control: DropdownControl;
  @Input() public formGroup: FormGroup;
  @Output() public dropdownChange = new EventEmitter(null);
  @Output() public onOverrideValue = new EventEmitter();

  constructor() {}

  public getSelectedOptionLabel(): string {
    const selectedKey = this.formGroup.get(this.control.key)?.value;
    const selectedOption = this.control.options?.find(opt => opt.key === selectedKey);

    return selectedOption ? selectedOption.value : '';
  }

  public onDropdownChange(event: any): void {
    this.dropdownChange.emit(event);
  }

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
